import {defer, Subject} from 'rxjs';
import {exhaustMap, map, shareReplay, startWith, switchMap, tap} from 'rxjs/operators';
import {loadJS} from '@px/helper/loadjs';

export const downloadImageNotifier$ = new Subject<{element: HTMLElement; fileName: string; backgroundColor?: string}>();

const loadHtml2Canvas = () => loadJS('html2canvas', 'https://s.phemex.com/100/3rd/html2canvas/1.4.1/html2canvas.min.js');
const html2Canvas$ = defer(() => loadHtml2Canvas()).pipe(
  // @ts-ignore
  map(() => window.html2canvas),
  shareReplay(1)
);

let saveBlobData;
function createSaveBlobDataFun() {
  let a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);

  return function saveBlobData(blob, fileName) {
    if (!blob) {
      return;
    }
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
}

export const downloadState$ = downloadImageNotifier$.pipe(
  exhaustMap((params) =>
    html2Canvas$.pipe(
      switchMap((html2Canvas) =>
        html2Canvas(params.element, {
          useCORS: true,
          scale: 2,
          backgroundColor: params.backgroundColor || params,
          onclone: function (clonedElement: Document) {
            const mirrorRootElement = clonedElement.getElementById('downloadMirror');
            if (mirrorRootElement) {
              mirrorRootElement.style.display = 'block';
            }
          },
        })
      ),
      switchMap(canvasToBlob),
      tap((blob) => {
        if (!saveBlobData) {
          saveBlobData = createSaveBlobDataFun();
        }
        saveBlobData(blob, params.fileName);
      }),
      map(() => ({loading: false})),
      startWith({loading: true})
    )
  ),
  startWith({loading: false})
);

function canvasToBlob(canvas) {
  return new Promise((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', 1);
  });
}
